(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aconcagua-homepage"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (root) => {
    const sliders = [];
    if (root.matches && root.matches('[data-ac-slideshow]')) sliders.push(root);
    if (root.querySelectorAll) sliders.push(...root.querySelectorAll('[data-ac-slideshow]'));

    sliders.forEach((slider) => {
      if (slider.dataset.acInitialized === 'true') return;
      slider.dataset.acInitialized = 'true';

      const slides = Array.from(slider.querySelectorAll('[data-ac-slide]'));
      const dots = Array.from(slider.querySelectorAll('[data-ac-slide-to]'));
      const toggle = slider.querySelector('[data-ac-toggle]');
      if (slides.length < 2 || !toggle) return;

      let activeIndex = 0;
      let userPaused = false;
      let timer;

      const stop = () => {
        window.clearInterval(timer);
        timer = undefined;
      };

      const start = () => {
        stop();
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (userPaused || reducedMotion || slider.matches(':hover') || slider.contains(document.activeElement)) return;
        timer = window.setInterval(() => show(activeIndex + 1), 6500);
      };

      const show = (index) => {
        activeIndex = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === activeIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === activeIndex;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-pressed', String(active));
        });
      };

      dots.forEach((dot) => dot.addEventListener('click', () => {
        show(Number(dot.dataset.acSlideTo));
        start();
      }));
      toggle.addEventListener('click', () => {
        userPaused = !userPaused;
        toggle.setAttribute('aria-pressed', String(userPaused));
        toggle.setAttribute('aria-label', userPaused ? 'Play slideshow' : 'Pause slideshow');
        toggle.querySelector('span').textContent = userPaused ? '▶' : 'Ⅱ';
        start();
      });
      slider.addEventListener('mouseenter', stop);
      slider.addEventListener('mouseleave', start);
      slider.addEventListener('focusin', stop);
      slider.addEventListener('focusout', (event) => {
        if (!slider.contains(event.relatedTarget)) start();
      });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stop();
        else start();
      });

      show(0);
      start();
    });
  };

  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
